import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import QuickViewWrapper from '../../../pages/quick-view';

const QuickViewPortalContainer = (props) => {
  const [modalRoot, setModalRoot] = useState(null);
  useEffect(() => {
    const root = document.createElement('div');
    root.setAttribute('id', 'portal-root');
    document.body.appendChild(root);
    setModalRoot(root);
    return () => {
      document.body.removeChild(root);
    };
  }, []);
  if (!modalRoot) return null;
  return ReactDOM.createPortal(
    <QuickViewWrapper {...props} />,
    modalRoot
  );
};
export default QuickViewPortalContainer;
